export default __webpack_public_path__ + "static/media/nff-logo.22489960.png";